import React, { Fragment, useState, useEffect } from "react";
import FileSaver from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";

import LockScreenLoading from "../../../LockScreenLoading/LockScreenLoading";

import { getProjectList } from "../../../../dataSource/pas";

import { pasDetailFormStyle } from "../../../../styles/jss/components/PAS/pasDetailFormStyle";

import { generatePdf } from "../../../../dataSource/pil";

const CustomCheckbox = withStyles({
  root: {
    color: blue[600],
    "&$disabled": {
      color: blue[100],
    },
  },
  checked: {},
  disabled: {},
})((props) => <Checkbox color="default" {...props} />);
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));
const PasPrintConfig = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const store = require("store");
  const userSitesRedux = useSelector((state) => state.userSitesRedux);
  const [printConfig, setPrintConfig] = useState({
    site_seq: [],
    to: "",
    cc: "",
  });
  const [siteSeqs, setSiteSeqs] = useState(
    userSitesRedux.map((obj) => obj.site_seq)
  );
  const [projectList, setProjectList] = useState({});

  const handleInputChange = (name) => (event) => {
    setPrintConfig({ ...printConfig, [name]: event.target.value });
  };

  // Handle Checkbox
  const handleCheckboxChange = (elementName) => (event) => {
    const { checked } = event.target;
    const data = { ...printConfig };

    if (checked) {
      data.site_seq.push(elementName);
    } else {
      if (data.site_seq.indexOf(elementName) > -1) {
        data.site_seq.splice(data.site_seq.indexOf(elementName), 1);
      }
    }
    data.site_seq.sort((a, b) =>
      a.site_seq < b.site_seq ? -1 : a.site_seq > b.site_seq ? 1 : 0
    );
    setPrintConfig({ ...printConfig, ...data });
  };

  const fetchProject = async () => {
    let submitBody = {};
    submitBody.site_seqs = siteSeqs;

    const response = await getProjectList(submitBody);
    setProjectList(response.data);
  };
  useEffect(() => {
    const getProject = async () => {
      fetchProject();
    };
    getProject();
  }, []);

  const submitPrint = () => {
    if (printConfig.site_seq.length === 0) {
      alert("You must select at least one project!");
    } else {
      confirmDialogHandleOpen({
        dialogTitle: "Print Project",
        dialogContent: "Are you sure to Print Project?",
        confirmAction: () => submitPrintConfirmAction(),
        cancelAction: confirmDialogHandleClose,
      });
    }
  };

  const submitPrintConfirmAction = async () => {
    confirmDialogHandleClose();
    setLockScreenLoadingOpen(true);
    const dateFormat = "DD/MM/YYYY ";
    let today = moment(new Date()).format(dateFormat);
    let data = { ...printConfig };
    data.site_seq = printConfig.site_seq.map((obj) => obj.site_seq).sort();
    let projToDisplayString = "";
    for (let i = 0; i < printConfig.site_seq.length; i++) {
      projToDisplayString = projToDisplayString.concat(`
        <div style="width:100%;float:left; page-break-after: always;">
             <div>
                  <span style="float:left">To:${printConfig.to}</span>
                  <span style="float:right">Date:${today}</span>
              </div>
              <br />
              <div>
                  <span style="float:left">CC:${printConfig.cc}</span>
              </div>
              <br />
              <div style="text-align:center">
                <p>PAS Hightlights for Project Team Attention</p>
                <p style="text-decoration: underline">Construction Team B Projects</p>
              </div>
              <br />
                <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%;">
                    <thead>
                    <tr style="background-color: rgb(238, 238, 238)">
                      <th style="width:15%;align:center;color:black"><strong>Project</strong></th>
                      <th style="width:40%;align:center;color:black"><strong>Sale Preparation Matters</strong></th>
                      <th style="width:35%;align:center;color:black"><strong>Progress/Quantity/Cost Matters</strong></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td style="color:black;margin: 12px 0px 12px 0px; text-align:center;line-height:20px;border-right:1px solid grey">
                        <p>${printConfig.site_seq[i].site_name}</p>
                        <p>${
                          printConfig.site_seq[i].managerName !== null
                            ? `( ${printConfig.site_seq[i].managerName} )`
                            : ""
                        }</p>
                      </td>
                      <td style="color:black;margin: 12px 0px 12px 0px;line-height:20px;border-right:1px solid grey">${
                        printConfig.site_seq[i].sale_preparation === null
                          ? ""
                          : printConfig.site_seq[i].sale_preparation
                      }</td>
                      <td style="color:black;margin: 12px 0px 12px 0px;line-height:20px">${
                        printConfig.site_seq[i].prog_qual_cost === null
                          ? ""
                          : printConfig.site_seq[i].prog_qual_cost
                      }</td>
                    </tr>
                  </tbody>
                </table>
            </div>
      `);
    }

    let htmlStr = `
      <html>
        <head>
            <meta charset="utf-8">
            <style>
                @page {
                  margin: 1cm;
                }
                @media print{                 
                }
            </style>
        </head>
        <body>
        <div style="font-size: 11px;margin:0">     
              ${projToDisplayString}   
          </div>
        </body>
    </html>
  `;
    const pdf = await generatePdf(htmlStr, "PAS HighLight");
    FileSaver.saveAs(pdf, `PAS HighLight.pdf`);
    setLockScreenLoadingOpen(false);
  };

  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });
    setConfirmDialogOpen(true);
  };
  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <Typography variant="h5">Print PAS HighLights</Typography>
      <hr />
      <Box className={classes.box} border={1} borderColor={"grey.400"}>
        <div style={{ padding: "8px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"to"}
                name={"to"}
                label={"To"}
                type="text"
                size="small"
                variant="outlined"
                value={printConfig.to || ""}
                onChange={handleInputChange("to")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"cc"}
                name={"cc"}
                label={"CC"}
                type="text"
                multiline
                rows={3}
                size="small"
                variant="outlined"
                value={printConfig.cc || ""}
                onChange={handleInputChange("cc")}
              />
            </Grid>
            {projectList.projList &&
              projectList.projList.map((obj, index) => {
                return (
                  <Grid item xs={12} key={index}>
                    <FormControlLabel
                      control={
                        <CustomCheckbox
                          required={true}
                          checked={
                            printConfig.site_seq.findIndex(
                              (proj) => proj.site_seq === obj.site_seq
                            ) > -1
                              ? true
                              : false
                          }
                          onChange={handleCheckboxChange(obj)}
                          disabled={
                            obj.sale_preparation !== null ||
                            obj.prog_qual_cost !== null
                              ? false
                              : true
                          }
                          name={obj.site_name}
                        />
                      }
                      label={obj.site_name}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </div>
      </Box>
      <br />
      <Grid item xs={12}>
        <Button onClick={submitPrint} variant="contained" color="primary">
          Submit
        </Button>
        &nbsp;
      </Grid>
    </Fragment>
  );
};

export default PasPrintConfig;
